import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import React from 'react'
import {
  IProps as IMultiFeatureSpotlight,
  ISlide,
} from 'marketing-site/src/library/components/MultiFeatureSpotlight'
import {
  IMultiFeatureSpotlight as IContentfulMultiFeatureSpotlight,
  IMultiFeatureSpotlightSlide as IContentfulMultiFeatureSpotlightSlide,
} from 'marketing-site/@types/generated/contentful'
import { transformCTALink } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { MultiFeatureSpotlight } from 'marketing-site/src/library/components/MultiFeatureSpotlight'
import * as Utils from 'marketing-site/src/library/utils'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'

export const ContentfulMultiFeatureSpotlight = (
  multiFeatureSpotlight: IContentfulMultiFeatureSpotlight,
) => (
  <EntryMarker entry={multiFeatureSpotlight}>
    {() => <MultiFeatureSpotlight {...transformMultiFeatureSpotlight(multiFeatureSpotlight)} />}
  </EntryMarker>
)

export function transformMultiFeatureSpotlight({ fields }: IContentfulMultiFeatureSpotlight) {
  const transformedData: Omit<IMultiFeatureSpotlight, 'isMobile'> = {
    ...fields,
    bgColor: Utils.getHexColorFromName(fields.backgroundColor),
    slides: fields.slides.map(transformMultiFeatureSpotlightSlide),
    icon: fields.icon && fields.icon.fields.file.url,
    cta: fields.cta && transformCTALink(fields.cta),
  }
  return transformedData
}

export function transformMultiFeatureSpotlightSlide({
  fields,
}: IContentfulMultiFeatureSpotlightSlide): ISlide {
  return {
    ...fields,
    text: documentToHtmlString(fields.richText),
    imageRef: transformImage(fields.imageRef),
    video: fields.video && fields.video.fields.file.url,
    videoWebm: fields.videoWebm && fields.videoWebm.fields.file.url,
  }
}
